// @flow

//
// React
//
import React from 'react';

//
// Type
//
import { type CellRendererProps } from '../../../../../lib/trix-web-components-table';

//
// Material UI
//
import TableCell from '@mui/material/TableCell';
import Chip from '@mui/material/Chip';

import { makeStyles } from '@mui/styles';

//
// Components
//
import { resolvePropertyValueType } from '../../../../../lib/trix-web-components-property';

//
// Styles
//
const useStyles = makeStyles(theme => ({
    root: {
        // take width of the content
        width: '1px',
        whiteSpace: 'nowrap',
    },
    link: {
        color: theme.palette.primary.main,
        textDecoration: 'none',
        '&:hover': {
            cursor: 'pointer',
        },
    }
}));

//
// Props
//
type Props = CellRendererProps & {
    //
    // Callbacks
    //
    onClick?: () => void,

    //
    // Data
    //
    value: any,
};

//
// Component
//
const PropertyValueTypeCellRenderer = (props: Props) => {
    //
    // Hooks
    //
    const classes = useStyles();

    const value = resolvePropertyValueType(props.value);

    return (
        <TableCell 
            padding="normal" 
            className={classes.root}
        >
            <Chip 
                label={value} 
                // variant='outlined' 
            />
        </TableCell>
    );
};
export default PropertyValueTypeCellRenderer;
